import { EntityRoutes } from 'routes/constants';
import strings from 'strings';
import { TALENT_POOL_URL } from 'UI/constants/defaults';
import { EntityType } from 'UI/constants/entityTypes';

import {
  formatApplicantMatchMakingResponse,
  formatCandidateMatchMakingResponse,
  formatContactMatchMakingResponse,
  formatJobOrderMatchMakingResponse
} from './MatchMakingTab.utils';

const REASON_COLUMN_MIN_WIDTH = 500;

export const CANDIDATE_COLUMNS = [
  {
    name: 'id',
    options: {
      display: 'excluded',
      sort: false
    }
  },
  {
    name: 'fullName',
    label: 'Full Name',
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: EntityRoutes.CandidateProfile,
          idKey: 'id',
          textKey: 'fullName',
          enableInTabRedirect: true
        }
      }
    }
  },
  {
    name: 'status',
    label: 'Status',
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          labelKey: 'title',
          baseClass: 'chip-joborder-status'
        }
      }
    }
  },
  {
    name: 'type',
    label: 'Type',
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          labelKey: 'title',
          baseClass: 'chip-joborder-type'
        }
      }
    }
  },
  {
    name: 'title',
    label: 'Title',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'functionalTitle',
    label: 'Functional Title',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'company',
    label: 'Company',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: EntityRoutes.CompanyProfile,
          textKey: 'name',
          enableInTabRedirect: true
        }
      }
    }
  },
  {
    name: 'industrySpecialty',
    label: 'Industry: Specialty',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'subspecialty',
    label: 'Subspecialty',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'location',
    label: 'Location',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'score',
    label: 'Score',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          idKey: 'score',
          labelKey: 'label',
          baseClass: 'chip-match-score'
        }
      }
    }
  },
  {
    name: 'lastActivityType',
    label: 'Last Activity Type',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'lastActivityBy',
    label: 'Last Activity By',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'lastActivityDate',
    label: 'Last Activity Date',
    options: {
      sort: false,
      display: true,
      renderer: 'date'
    }
  },
  {
    name: 'createdAt',
    label: 'Added Date',
    options: {
      sort: false,
      display: true,
      renderer: 'date'
    }
  },
  {
    name: 'reason',
    label: 'Reasons of Match',
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => ({ style: { minWidth: REASON_COLUMN_MIN_WIDTH } })
    }
  }
];

export const JOB_ORDER_COLUMNS = [
  {
    name: 'id',
    options: {
      display: 'excluded',
      sort: false
    }
  },
  {
    name: 'status',
    label: 'Status',
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          labelKey: 'title',
          baseClass: 'chip-candidate-status',
          variant: 'outlined'
        }
      }
    }
  },
  {
    name: 'type',
    label: 'Type',
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          labelKey: 'title',
          baseClass: 'chip-candidate-type',
          colorKey: 'typeId'
        }
      }
    }
  },
  {
    name: 'title',
    label: 'Title',
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: EntityRoutes.JobOrderProfile,
          idKey: 'id',
          textKey: 'title',
          enableInTabRedirect: true
        }
      }
    }
  },
  {
    name: 'functionalTitle',
    label: 'Job Function',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'company',
    label: 'Company',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: EntityRoutes.CompanyProfile,
          textKey: 'name',
          enableInTabRedirect: true
        }
      }
    }
  },
  {
    name: 'industrySpecialty',
    label: 'Industry: Specialty',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'subspecialty',
    label: 'Subspecialty',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'location',
    label: 'Location',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'score',
    label: 'Score',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          idKey: 'score',
          labelKey: 'label',
          baseClass: 'chip-match-score'
        }
      }
    }
  },
  {
    name: 'lastActivityType',
    label: 'Last Activity Type',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'lastActivityBy',
    label: 'Last Activity By',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'lastActivityDate',
    label: 'Last Activity Date',
    options: {
      sort: false,
      display: true,
      renderer: 'date'
    }
  },
  {
    name: 'createdAt',
    label: 'Added Date',
    options: {
      sort: false,
      display: true,
      renderer: 'date'
    }
  },
  {
    name: 'reason',
    label: 'Reasons of Match',
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => ({ style: { minWidth: REASON_COLUMN_MIN_WIDTH } })
    }
  }
];

export const CONTACT_COLUMNS = [
  {
    name: 'id',
    options: {
      display: 'excluded',
      sort: false
    }
  },
  {
    name: 'fullName',
    label: 'Full Name',
    options: {
      sort: false,
      display: true,
      renderer: 'contactLink'
    }
  },
  {
    name: 'companyType',
    label: 'Company Type',
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          labelKey: 'title',
          baseClass: 'chip-company-type'
        }
      }
    }
  },
  {
    name: 'companyName',
    label: 'Company',
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: EntityRoutes.CompanyProfile,
          textKey: 'name',
          enableInTabRedirect: true
        }
      }
    }
  },
  {
    name: 'functionalTitle',
    label: 'Job Function',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'role',
    label: 'Role',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'industrySpecialty',
    label: 'Industry: Specialty',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'subspecialty',
    label: 'Subspecialty',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'status',
    label: 'Status',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'location',
    label: 'Location',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'score',
    label: 'Score',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          idKey: 'score',
          labelKey: 'label',
          baseClass: 'chip-match-score'
        }
      }
    }
  },
  {
    name: 'lastActivityType',
    label: 'Last Activity Type',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'lastActivityBy',
    label: 'Last Activity By',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'lastActivityDate',
    label: 'Last Activity Date',
    options: {
      sort: false,
      display: true,
      renderer: 'date'
    }
  },
  {
    name: 'createdAt',
    label: 'Added Date',
    options: {
      sort: false,
      display: true,
      renderer: 'date'
    }
  },
  {
    name: 'reason',
    label: 'Reasons of Match',
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => ({ style: { minWidth: REASON_COLUMN_MIN_WIDTH } })
    }
  }
];

export const APPLICANT_COLUMNS = [
  {
    name: 'id',
    options: {
      display: 'excluded',
      sort: false
    }
  },
  {
    name: 'fullName',
    label: 'Full Name',
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: `${TALENT_POOL_URL}/${EntityRoutes.TalentPoolApplicantProfile}`,
          idKey: 'id',
          textKey: 'name',
          enableInTabRedirect: false,
          isExternal: true
        }
      }
    }
  },
  {
    name: 'title',
    label: 'Advert Title',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'location',
    label: 'Location',
    options: {
      sort: false,
      display: true
    }
  },
  {
    name: 'score',
    label: 'Score',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          idKey: 'score',
          labelKey: 'label',
          baseClass: 'chip-match-score'
        }
      }
    }
  },
  {
    name: 'lastApplicationDate',
    label: 'Last Application Date',
    options: {
      sort: false,
      display: true,
      renderer: 'date'
    }
  },
  {
    name: 'reason',
    label: 'Reasons of Match',
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => ({ style: { minWidth: REASON_COLUMN_MIN_WIDTH } })
    }
  },
  {
    name: 'advertReference',
    label: 'Advert Reference',
    options: {
      sort: false,
      display: false
    }
  },
  {
    name: 'source',
    label: 'Source',
    options: {
      sort: false,
      display: false
    }
  }
];

export const JOB_ORDER_MATCH_MAKING_COLUMNS_BY_ENTITY_TYPE = {
  [EntityType.Candidate]: CANDIDATE_COLUMNS,
  [EntityType.Applicant]: APPLICANT_COLUMNS
};

export const JOB_ORDER_MATCH_MAKING_FORMATTERS_BY_ENTITY_TYPE = {
  [EntityType.Candidate]: formatCandidateMatchMakingResponse,
  [EntityType.Applicant]: formatApplicantMatchMakingResponse
};

export const CANDIDATE_MATCH_MAKING_COLUMNS_BY_ENTITY_TYPE = {
  [EntityType.Contact]: CONTACT_COLUMNS,
  [EntityType.Joborder]: JOB_ORDER_COLUMNS
};

export const CANDIDATE_MATCH_MAKING_FORMATTERS_BY_ENTITY_TYPE = {
  [EntityType.Contact]: formatContactMatchMakingResponse,
  [EntityType.Joborder]: formatJobOrderMatchMakingResponse
};

export const COPIES = strings.inventory.matchMaking;
